import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import "@thos/Store/Reducer";
import { css } from "styled-components";

// Load all custom widgets so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const widgets = require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

setPreStyleGuideTheme({
    colors: {
        primary: {
            main: "#D18A44",
        },
        secondary: {
            main: "#007047",
        },
        warning: {
            main: "#CD2F00",
        },
    },
    globalStyle: {
        css: css`
            [class^="GridItemStyle"] {
                overflow-wrap: normal;
                word-break: normal;
            }

            [data-test-selector="productListCardContainerList"] {
                padding-left: 25px;
                padding-right: 25px;
            }

            #react-app > [data-test-selector^="page"] {
                display: flex;
                flex-direction: column;
                min-height: 100vh;
            }

            #react-app > [data-test-selector^="page"] > main {
                flex: 1;
            }
        `,
    },
});

setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 1100, 1370],
        maxWidths: [540, 540, 720, 960, 1370],
    },
});
